// removed by extract-text-webpack-plugin
module.exports = {"portrait":"portrait","hasPhoto":"hasPhoto","teacher-invite-status":"teacher-invite-status","created":"created","invited":"invited","confirm":"confirm","declined":"declined"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Teacher/TeacherTable/TeacherTable.scss
// module id = 2rzK
// module chunks = 0